// Hooks da JORNADA de primeiro acesso. Mesmo padrão de use-costs.ts:
//   - `src/api/onboarding.ts` guarda o request (fetch + tipos), sem React;
//   - este arquivo guarda as CHAVES e os hooks do TanStack Query;
//   - a tela não importa a função de api: importa o hook.
import { useQuery } from "@tanstack/react-query";
import { getJourney } from "@/api/onboarding";
import { useActiveOrganization } from "@/lib/auth-client";

// A chave DESTE domínio. É uma só, e é COMPARTILHADA de propósito por quatro
// pontas: o card da Home, a tela /jornada, o contador da navegação
// (use-journey-progress.ts) e o invalidador de use-users.ts (convidar ou criar
// membro fecha o passo "Convide o time"). Uma entrada de cache só é o que faz a
// jornada custar um request por sessão, e não um por ponta.
//
// Morava literal nas três telas e em `userKeys.journey` (com um comentário
// dizendo "quando o domínio de onboarding sair, esta linha vai junto"). Saiu:
// use-users.ts agora aponta para cá. String por string, sem renomear.
export const onboardingKeys = {
  journey: ["onboarding", "journey"] as const,
};

// A jornada é POR MARCA ATIVA: sem org não há o que buscar, e é isso que o
// `enabled: !!org?.id` de todas as pontas fazia. Fica aqui — as quatro pontas
// repetiam a mesma linha, e uma delas esquecer o gate significaria um 4xx a
// cada troca de marca.
export function useJourney() {
  const { data: org } = useActiveOrganization();
  return useQuery({
    queryKey: onboardingKeys.journey,
    queryFn: getJourney,
    enabled: !!org?.id,
  });
}
